module.exports = __webpack_public_path__ + "static/img/bgimg3-1.e2f04ea6.png";